module.exports = __webpack_public_path__ + "static/media/beforePic.48063db1.png";